import { useState, useEffect } from 'react';
import './Drawcanvas.css';

function Player(props) {
  const [player, setPlayer] = useState(props.player);
  const [playerColour, setPlayerColour] = useState((props.player !== undefined) ? props.player.colour : "#EAC24D");
  useEffect(() => {
    if (props.player != undefined) {
      setPlayer(props.player);
    }
  }, [props.player]);

  useEffect(() => {
    if (props.player != undefined) {
      setPlayerColour(props.player.colour);
    }
  }, [props.player]);

  if (player == undefined || player.name == undefined) {
    return (
      <span className='m-0 rounded-lg border-none playerName xl:text-lg text-sm truncate text-white w-full p-2 md:py-1 align-middle' style={{ backgroundColor: `${playerColour}` }}>Loading...</span>
    );
  }
  
  return (
    <span className='m-0 rounded-lg border-none playerName xl:text-lg text-sm truncate text-white w-full p-2 md:py-1 align-middle' style={{ backgroundColor: `${playerColour}` }}>{player.name}</span>
  );

}

export default Player;
